'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Path = require('./Path');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Circle = function Circle(x, y, radius) {
  _classCallCheck(this, Circle);

  this.type = _Path.PATH.CIRCLE;
  this.x = x;
  this.y = y;
  this.radius = radius;

  if (process.env.NODE_ENV !== 'production') {
    if (isNaN(x)) {
      console.error('Invalid x value given for Circle');
    }

    if (isNaN(y)) {
      console.error('Invalid y value given for Circle');
    }

    if (isNaN(radius)) {
      console.error('Invalid radius value given for Circle');
    }
  }
};

exports.default = Circle;